// extracted by mini-css-extract-plugin
export default {"menu":"FooterChildren_menu__1ZmnC"};